export const API_BASE = `${__BASE_PATH__}api`.replace(/\/+/g, "/");
